<template>
  <div>
    <v-card class="overflow-hidden ma-5">
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              :label="$t('transfer_order_number')"
              v-model="filterTransferOrder.Number"
              @input="getTransferOrder"
            ></v-text-field>
          </v-col>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterTransferOrder"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterTransferOrder.LicensePlate"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn class="mt-2" color="primary" @click="getTransferOrder">
              {{ $t('common_search') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="transferOrderDataTableHeaders"
      :items="transferOrderList"
      :search="searchTransferOrder"
      class="elevation-1 ma-5"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :loading="isLoadingTransferOrder"
      :loading-text="$t('common_get_data')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchTransferOrder"
            append-icon="mdi-magnify"
            :label="$t('common_search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-toolbar>
        <v-dialog v-model="isShowEditedTransferOrderDialog" fullscreen persistent>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ $t('common_edit') }}</span>
              <v-chip class="ml-3" color="primary" text-color="white">
                {{ $t('quotation_number') }}: {{ editedTransferOrder.QuotationNumber }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="openOriginalQuotation">
                {{ $t('warehouse_check_view_quotation') }}
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.Number"
                    :label="$t('transfer_order_order_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.Customer.Number"
                    :label="$t('transfer_order_customer_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.Customer.ShortName"
                    :label="$t('transfer_order_customer_short_name')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.Customer.FullName"
                    :label="$t('transfer_order_customer_full_name')"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.LicensePlateList"
                    :label="$t('transfer_order_license_plate')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.ItemAmt"
                    :label="$t('transfer_order_original_amount')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.NewItemAmt"
                    :label="$t('transfer_order_modified_amount')"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.QuotationNumber"
                    :label="$t('transfer_order_original_quotation_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.NewQuotationNumber"
                    :label="$t('transfer_order_new_quotation_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.ErpTransferOrderNumber"
                    :label="$t('transfer_order_erp_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.InvalidReason"
                    :label="$t('transfer_order_invalid_reason')"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="errorMessage">
                <v-col cols="12">
                  <v-alert type="error" variant="tonal" density="comfortable" prominent>
                    <div class="text-h6 mb-2">
                      {{ $t('transfer_order_price_detail_missing') }}
                    </div>
                    <pre class="error-message">{{ errorMessage }}</pre>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-data-table
                    :headers="transferOrderOriginalItemDataTableHeaders"
                    :items="newTransferOrderItems"
                    :search="searchTransferOrderItem"
                    class="elevation-1 ma-5"
                    item-key="Index"
                    :no-data-text="$t('common_no_data')"
                    :no-results-text="$t('common_no_results')"
                    :loading-text="$t('common_get_data')"
                    :footer-props="{
                      'items-per-page-options': [30, 50, 100],
                      'items-per-page-text': $t('item_rows_per_page'),
                    }"
                    :header-props="headerProps"
                  >
                    <template v-slot:item="{ item, expand, isExpanded }">
                      <tr>
                        <td v-if="item.NewQuotationItem && item.NewQuotationItem.Id">
                          {{ $t('transfer_order_modified') }}
                        </td>
                        <td v-else-if="item.OriginalQuotationItem.IsDelete">
                          {{ $t('transfer_order_deleted') }}
                        </td>
                        <td v-else>{{ $t('transfer_order_no_change') }}</td>
                        <td class="text-start">
                          {{ item.OriginalQuotationItem.Number }}
                        </td>
                        <td class="text-start">
                          {{ item.OriginalQuotationItem.Describe }}
                        </td>
                        <td class="text-start">
                          {{ item.OriginalQuotationItem.Name }}
                        </td>
                        <td class="text-start">
                          {{ item.OriginalQuotationItem.Unit }}
                        </td>
                        <td class="text-end">
                          {{ item.OriginalQuotationItem.Quantity }}
                        </td>
                        <td class="text-end">
                          {{ item.OriginalQuotationItem.TotalQuantity }}
                        </td>
                        <td v-if="item.OriginalQuotationItem.Number"></td>
                        <td v-if="!item.OriginalQuotationItem.Number" class="text-start">
                          <v-icon @click="expand(!isExpanded)" v-if="isExpanded">
                            mdi-chevron-up
                          </v-icon>
                          <v-icon @click="expand(!isExpanded)" v-else>
                            mdi-chevron-down
                          </v-icon>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ item }">
                      <tr v-for="field in item.OriginalQuotationItem.BomItems" :key="field.Number">
                        <td></td>
                        <td class="text-start">
                          {{ field.Number }}
                        </td>
                        <td class="text-start">
                          {{ field.Describe }}
                        </td>
                        <td class="text-start">
                          {{ field.Name }}
                        </td>
                        <td class="text-start">
                          {{ field.Unit }}
                        </td>
                        <td class="text-end">
                          {{ field.Quantity }}
                        </td>
                        <td class="text-end">
                          {{ field.TotalQuantity }}
                        </td>
                        <td></td>
                      </tr>
                    </template>
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Before</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                          v-model="searchTransferOrderItem"
                          append-icon="mdi-magnify"
                          :label="$t('common_search')"
                          single-line
                          hide-details
                          clearable
                        ></v-text-field>
                      </v-toolbar>
                      <v-dialog v-model="isShowEditedTransferOrderItemDialog" fullscreen persistent>
                        <v-card>
                          <v-card-title>
                            <span class="text-h5"></span>
                            <v-spacer></v-spacer>
                          </v-card-title>
                          <ValidationObserver ref="transferOrderItem">
                            <v-card-text
                              v-if="
                                editedTransferOrderItem.OriginalQuotationItem &&
                                  !editedTransferOrderItem.OriginalQuotationItem.Number
                              "
                            >
                              <v-row>
                                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.OriginalQuotationItem.Name"
                                    :label="$t('quotation_item_name')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.OriginalQuotationItem.Describe"
                                    :label="$t('transfer_order_bom_describe')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.OriginalQuotationItem.Quantity"
                                    :label="$t('transfer_order_install_quantity')"
                                    disabled
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col>
                                  <v-autocomplete
                                    v-model="
                                      editedTransferOrderItem.OriginalQuotationItem.InstallPositions
                                    "
                                    :items="allInstallPositionsType"
                                    item-text="Name"
                                    item-value="Type"
                                    :label="$t('quotation_item_install_position')"
                                    small-chips
                                    multiple
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    disabled
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                                  <v-autocomplete
                                    :items="bomList"
                                    item-text="Name"
                                    item-value="Id"
                                    return-object
                                    v-model="editedTransferOrderItem.NewQuotationItem.Id"
                                    disabled
                                    :label="$t('transfer_order_bom_name')"
                                  >
                                    <template v-slot:item="data">
                                      <template>
                                        <v-list-item-content>
                                          <v-list-item-title>
                                            {{ data.item.Name }}
                                          </v-list-item-title>
                                          <v-list-item-subtitle>
                                            {{ data.item.Describe }}
                                          </v-list-item-subtitle>
                                        </v-list-item-content>
                                      </template>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.NewQuotationItem.Describe"
                                    :label="$t('transfer_order_bom_describe')"
                                    disabled
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.NewQuotationItem.Quantity"
                                    disabled
                                    :label="$t('transfer_order_install_quantity')"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col>
                                  <v-autocomplete
                                    v-model="
                                      editedTransferOrderItem.NewQuotationItem.InstallPositions
                                    "
                                    :items="allInstallPositionsType"
                                    item-text="Name"
                                    item-value="Type"
                                    :label="$t('quotation_item_install_position')"
                                    small-chips
                                    multiple
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    disabled
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text v-else>
                              <v-row>
                                <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.OriginalQuotationItem.Number"
                                    disabled
                                    :label="$t('transfer_order_item_number')"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.OriginalQuotationItem.Name"
                                    disabled
                                    :label="$t('transfer_order_item_name')"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.OriginalQuotationItem.Quantity"
                                    disabled
                                    :label="$t('transfer_order_install_quantity')"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                  <v-autocomplete
                                    v-model="
                                      editedTransferOrderItem.OriginalQuotationItem.InstallPositions
                                    "
                                    :items="allInstallPositionsType"
                                    item-text="Name"
                                    item-value="Type"
                                    :label="$t('quotation_item_install_position')"
                                    small-chips
                                    multiple
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    disabled
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.NewQuotationItem.Name"
                                    disabled
                                    :label="$t('transfer_order_item_number')"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.NewQuotationItem.Name"
                                    disabled
                                    :label="$t('transfer_order_item_name')"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                  <v-text-field
                                    v-model="editedTransferOrderItem.NewQuotationItem.Quantity"
                                    disabled
                                    :label="$t('transfer_order_install_quantity')"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                  <v-autocomplete
                                    v-model="
                                      editedTransferOrderItem.NewQuotationItem.InstallPositions
                                    "
                                    :items="allInstallPositionsType"
                                    item-text="Name"
                                    item-value="Type"
                                    :label="$t('quotation_item_install_position')"
                                    small-chips
                                    multiple
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    disabled
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </ValidationObserver>
                          <v-data-table
                            :headers="bomItemDataTableHeaders"
                            :items="editedTransferOrderItem.NewQuotationItem.BomItems"
                            :search="searchBomItem"
                            class="elevation-1 ma-5"
                            :no-data-text="$t('common_no_data')"
                            :no-results-text="$t('common_no_results')"
                            :loading-text="$t('common_get_data')"
                            :footer-props="{
                              'items-per-page-options': [30, 50, 100],
                              'items-per-page-text': $t('item_rows_per_page'),
                            }"
                            :header-props="headerProps"
                            v-if="
                              editedTransferOrderItem.OriginalQuotationItem &&
                                !editedTransferOrderItem.OriginalQuotationItem.Number
                            "
                          >
                            <template v-slot:top>
                              <v-toolbar flat>
                                <v-toolbar-title></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-text-field
                                  v-model="searchBomItem"
                                  append-icon="mdi-magnify"
                                  :label="$t('common_search')"
                                  single-line
                                  hide-details
                                  clearable
                                ></v-text-field>
                              </v-toolbar>
                            </template>
                          </v-data-table>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" text @click="closeEditedTransferOrderItem">
                              {{ $t('common_close') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="6">
                  <v-data-table
                    :headers="transferOrderNewItemDataTableHeaders"
                    :items="afterTransferOrderItems"
                    :search="searchTransferOrderItem"
                    class="elevation-1 ma-5"
                    item-key="Index"
                    :no-data-text="$t('common_no_data')"
                    :no-results-text="$t('common_no_results')"
                    :loading-text="$t('common_get_data')"
                    :footer-props="{
                      'items-per-page-options': [30, 50, 100],
                      'items-per-page-text': $t('item_rows_per_page'),
                    }"
                    :header-props="headerProps"
                  >
                    <template v-slot:item="{ item, expand, isExpanded }">
                      <tr>
                        <td
                          class="text-start"
                          v-if="item.OriginalQuotationItem && item.OriginalQuotationItem.Id"
                        ></td>
                        <td v-else>{{ $t('transfer_order_add') }}</td>
                        <td class="text-start">
                          {{ item.NewQuotationItem.Number }}
                        </td>
                        <td class="text-start">
                          {{ item.NewQuotationItem.Describe }}
                        </td>
                        <td class="text-start">
                          {{ item.NewQuotationItem.Name }}
                        </td>
                        <td class="text-start">
                          {{ item.NewQuotationItem.Unit }}
                        </td>
                        <td class="text-end">
                          {{ item.NewQuotationItem.Quantity }}
                        </td>
                        <td class="text-end">
                          {{ item.NewQuotationItem.TotalQuantity }}
                        </td>
                        <td v-if="item.NewQuotationItem.Number"></td>
                        <td v-if="!item.NewQuotationItem.Number" class="text-start">
                          <v-icon @click="expand(!isExpanded)" v-if="isExpanded">
                            mdi-chevron-up
                          </v-icon>
                          <v-icon @click="expand(!isExpanded)" v-else>
                            mdi-chevron-down
                          </v-icon>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ item }">
                      <tr v-for="field in item.NewQuotationItem.BomItems" :key="field.Number">
                        <td></td>
                        <td class="text-start">
                          {{ field.Number }}
                        </td>
                        <td class="text-start">
                          {{ field.Describe }}
                        </td>
                        <td class="text-start">
                          {{ field.Name }}
                        </td>
                        <td class="text-start">
                          {{ field.Unit }}
                        </td>
                        <td class="text-end">
                          {{ field.Quantity }}
                        </td>
                        <td class="text-end">
                          {{ field.TotalQuantity }}
                        </td>
                        <td></td>
                      </tr>
                    </template>
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>After</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                          v-model="searchTransferOrderItem"
                          append-icon="mdi-magnify"
                          :label="$t('common_search')"
                          single-line
                          hide-details
                          clearable
                        ></v-text-field>
                      </v-toolbar>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="closeEditedTransferOrderDialog">
                {{ $t('common_close') }}
              </v-btn>
              <v-btn
                color="success"
                text
                @click="returnToStock"
                :disabled="editedTransferOrder.IsInvalid"
              >
                {{ $t('transfer_order_reject_return_to_stock') }}
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="submitToDone"
                :disabled="editedTransferOrder.IsInvalid || errorMessage !== ''"
              >
                {{ $t('transfer_order_confirm_throw_erp') }}
              </v-btn>
              <v-btn
                color="secondary"
                text
                @click="isShowInvalidAllDialog = true"
                :disabled="editedTransferOrder.IsInvalid || errorMessage !== ''"
              >
                {{ $t('transfer_order_invalid_all_reopen') }}
              </v-btn>
              <v-dialog v-model="isShowInvalidAllDialog" persistent max-width="600px">
                <v-card>
                  <v-card-title>{{ $t('transfer_order_confirm_invalid') }}</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col>
                        <ValidationObserver ref="invalidAll">
                          <ValidationProvider
                            :name="$t('transfer_order_invalid_reason')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-textarea
                              outlined
                              v-model="invalidReason"
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('transfer_order_invalid_reason') }}
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                        </ValidationObserver>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="closeInvalidAllDialog">
                      {{ $t('common_cancel') }}
                    </v-btn>
                    <v-btn color="success" text @click="invalidAll">
                      {{ $t('common_confirm') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- 原報價單只讀 dialog -->
        <v-dialog v-model="isShowOriginalQuotationDialog" max-width="1200" persistent>
          <v-card>
            <v-card-title>
              {{ $t('warehouse_check_original_quotation') }} -
              {{ editedTransferOrder.QuotationNumber }}
              <v-spacer></v-spacer>
              <v-btn icon @click="isShowOriginalQuotationDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="quotationItemHeaders"
                :items="originalQuotationItems"
                :no-data-text="$t('common_no_data')"
                disable-pagination
                hide-default-footer
                dense
              >
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditedTransferOrderDialogBtn(item)">
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.LicensePlateList`]="{ item }">
        <div v-if="item.LicensePlateList.length > 2">
          <v-chip v-for="index in 2" :key="index" small>
            {{ item.LicensePlateList[index - 1] }}
          </v-chip>
          +({{ item.LicensePlateList.length - 2 }})
        </div>
        <div v-else>
          <v-chip v-for="licensePlate in item.LicensePlateList" :key="licensePlate" small>
            {{ licensePlate }}
          </v-chip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  HttpTransferOrder,
  HttpBom,
  HttpInstallPosition,
  HttpCustomerRepair
} from '@/js/http-Manager'
import { TransferOrderStatus } from '@/js/TransferOrderStatus'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
extend('regex', regex)
export default {
  components: { CustomerAutocompleteFilter },
  name: 'SaleTransferOrder',
  props: {
    tabValue: {
      type: String
    }
  },
  data: () => ({
    transferOrderStatus: TransferOrderStatus,
    notInCustomerTimer: null,
    errorMessage: '',
    isShowInvalidAllDialog: false,
    invalidReason: '',
    bomList: [],
    isAllTextFieldDisabled: false,
    isLoadingTransferOrder: false,
    transferOrderList: [],
    searchTransferOrder: '',
    filterTransferOrder: {
      CustomerId: '',
      LicensePlate: '',
      Number: ''
    },
    editedTransferOrderIndex: -1,
    editedTransferOrder: {
      Number: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      QuotationNumber: '',
      ErpTransferOrderNumber: '',
      NewQuotationNumber: '',
      ItemAmt: 0,
      NewItemAmt: 0,
      IsThrowErp: false,
      IsInvalid: false,
      InvalidBy: '',
      InvalidTime: 0,
      InvalidReason: '',
      Status: 0,
      LicensePlateList: [],
      TransferOrderItems: []
    },
    defaultTransferOrder: {
      Number: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      QuotationNumber: '',
      ErpTransferOrderNumber: '',
      NewQuotationNumber: '',
      ItemAmt: 0,
      NewItemAmt: 0,
      IsThrowErp: false,
      IsInvalid: false,
      InvalidBy: '',
      InvalidTime: 0,
      InvalidReason: '',
      Status: 0,
      LicensePlateList: [],
      TransferOrderItems: []
    },
    isShowEditedTransferOrderDialog: false,
    isShowEditedTransferOrderItemDialog: false,
    editedTransferOrderItemIndex: -1,
    searchTransferOrderItem: '',
    editedTransferOrderItem: {
      OriginalQuotationItem: {
        Number: '',
        Name: '',
        Quantity: 0,
        BuyQuantity: 0,
        RentQuantity: 0,
        Unit: '',
        TotalQuantity: 0,
        Price: 0,
        DiscountPrice: 0,
        Discount: 0,
        RepairPrice: 0,
        TotalPrice: 0,
        RepairWarrantyPeriod: 0,
        WarrantyPeriod: 0,
        InstallPositions: [],
        CustomerDeviceType: 0,
        IsCustomerDevice: false,
        Remark: '',
        Describe: '',
        Custody: 0,
        IsOptionalItem: false,
        BomItems: [],
        IsNeedInstall: true
      },
      NewQuotationItem: {
        Number: '',
        Name: '',
        Quantity: 0,
        BuyQuantity: 0,
        RentQuantity: 0,
        Unit: '',
        TotalQuantity: 0,
        Price: 0,
        DiscountPrice: 0,
        Discount: 0,
        RepairPrice: 0,
        TotalPrice: 0,
        RepairWarrantyPeriod: 0,
        WarrantyPeriod: 0,
        InstallPositions: [],
        CustomerDeviceType: 0,
        IsCustomerDevice: false,
        Remark: '',
        Describe: '',
        Custody: 0,
        IsOptionalItem: false,
        BomItems: [],
        IsNeedInstall: true
      }
    },
    defaultTransferOrderItem: {
      OriginalQuotationItem: {
        Number: '',
        Name: '',
        Quantity: 0,
        BuyQuantity: 0,
        RentQuantity: 0,
        Unit: '',
        TotalQuantity: 0,
        Price: 0,
        DiscountPrice: 0,
        Discount: 0,
        RepairPrice: 0,
        TotalPrice: 0,
        RepairWarrantyPeriod: 0,
        WarrantyPeriod: 0,
        InstallPositions: [],
        CustomerDeviceType: 0,
        IsCustomerDevice: false,
        Remark: '',
        Describe: '',
        Custody: 0,
        IsOptionalItem: false,
        BomItems: [],
        IsNeedInstall: true
      },
      NewQuotationItem: {
        Number: '',
        Name: '',
        Quantity: 0,
        BuyQuantity: 0,
        RentQuantity: 0,
        Unit: '',
        TotalQuantity: 0,
        Price: 0,
        DiscountPrice: 0,
        Discount: 0,
        RepairPrice: 0,
        TotalPrice: 0,
        RepairWarrantyPeriod: 0,
        WarrantyPeriod: 0,
        InstallPositions: [],
        CustomerDeviceType: 0,
        IsCustomerDevice: false,
        Remark: '',
        Describe: '',
        Custody: 0,
        IsOptionalItem: false,
        BomItems: [],
        IsNeedInstall: true
      }
    },
    searchBomItem: '',
    allInstallPositionsType: [],
    isShowOriginalQuotationDialog: false,
    originalQuotationItems: []
  }),
  async mounted () {
    await this.getTransferOrder()
    await this.getAllBoms()
    await this.getAllInstallPositionsType()
  },
  watch: {
    async tabValue () {
      if (this.tabValue === 'tab-2') {
        await this.getTransferOrder()
      }
    }
  },
  computed: {
    afterTransferOrderItems () {
      let array = []
      this.editedTransferOrder.TransferOrderItems.forEach((element, index) => {
        if (element.NewQuotationItem && element.NewQuotationItem.Id) {
          element.Index = index
          array.push(element)
        }
      })
      return array
    },
    newTransferOrderItems () {
      let array = []
      this.editedTransferOrder.TransferOrderItems.forEach((element, index) => {
        if (element.OriginalQuotationItem && element.OriginalQuotationItem.Id) {
          element.Index = index
          array.push(element)
        }
      })
      return array
    },
    transferOrderDataTableHeaders () {
      return [
        { text: this.$t('transfer_order_order_number'), value: 'Number' },
        { text: this.$t('transfer_order_customer_number'), value: 'Customer.Number' },
        { text: this.$t('transfer_order_customer_short_name'), value: 'Customer.ShortName' },
        { text: this.$t('transfer_order_customer_full_name'), value: 'Customer.FullName' },
        { text: this.$t('transfer_order_license_plate_list'), value: 'LicensePlateList' },
        { text: this.$t('transfer_order_quotation_original_amount'), value: 'ItemAmt' },
        { text: this.$t('transfer_order_quotation_modified_amount'), value: 'NewItemAmt' },
        { text: this.$t('transfer_order_invalid_reason'), value: 'InvalidReason' },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    quotationItemHeaders () {
      return [
        { text: this.$t('quotation_item_number'), value: 'Number' },
        { text: this.$t('quotation_item_name'), value: 'Name' },
        { text: this.$t('quotation_item_unit'), value: 'Unit' },
        { text: this.$t('quotation_item_quantity'), value: 'Quantity', align: 'end' },
        { text: this.$t('quotation_item_total_quantity'), value: 'TotalQuantity', align: 'end' },
        { text: this.$t('transfer_order_describe'), value: 'Describe' }
      ]
    },
    bomItemDataTableHeaders () {
      return [
        { text: this.$t('bom_item_number'), value: 'Number' },
        { text: this.$t('bom_item_name'), value: 'Name' },
        { text: this.$t('bom_item_quantity'), value: 'Quantity' }
      ]
    },
    transferOrderOriginalItemDataTableHeaders () {
      return [
        {
          text: this.$t('transfer_order_delete_or_update'),
          align: 'start',
          value: 'IsDeleteOrUpdate'
        },
        {
          text: this.$t('quotation_item_number'),
          align: 'start',
          value: 'OriginalQuotationItem.Number'
        },
        {
          text: this.$t('transfer_order_describe'),
          align: 'start',
          value: 'OriginalQuotationItem.Describe'
        },
        {
          text: this.$t('quotation_item_name'),
          align: 'start',
          value: 'OriginalQuotationItem.Name'
        },
        {
          text: this.$t('quotation_item_unit'),
          align: 'start',
          value: 'OriginalQuotationItem.Unit'
        },
        {
          text: this.$t('quotation_item_quantity'),
          align: 'end',
          value: 'OriginalQuotationItem.Quantity'
        },
        {
          text: this.$t('quotation_item_total_quantity'),
          align: 'end',
          value: 'OriginalQuotationItem.TotalQuantity'
        },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    transferOrderNewItemDataTableHeaders () {
      return [
        {
          text: this.$t('transfer_order_add'),
          align: 'start',
          value: 'IsAdd'
        },
        {
          text: this.$t('quotation_item_number'),
          align: 'start',
          value: 'NewQuotationItem.Number'
        },
        {
          text: this.$t('transfer_order_describe'),
          align: 'start',
          value: 'NewQuotationItem.Describe'
        },
        {
          text: this.$t('quotation_item_name'),
          align: 'start',
          value: 'NewQuotationItem.Name'
        },
        {
          text: this.$t('quotation_item_unit'),
          align: 'start',
          value: 'NewQuotationItem.Unit'
        },
        {
          text: this.$t('quotation_item_quantity'),
          align: 'end',
          value: 'NewQuotationItem.Quantity'
        },
        {
          text: this.$t('quotation_item_total_quantity'),
          align: 'end',
          value: 'NewQuotationItem.TotalQuantity'
        },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    }
  },
  methods: {
    async getAllInstallPositionsType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionsType = response && response.status === 200 ? response.data.Data : []
    },
    async getAllBoms () {
      let response = await HttpBom.GetAllBoms()
      this.bomList = response && response.status === 200 ? response.data.Data : []
    },
    isShowEditItemDialogBtn (item) {
      this.editedTransferOrderItemIndex = this.newTransferOrderItems.indexOf(item)
      this.editedTransferOrderItem = JSON.parse(JSON.stringify(item))
      this.isShowEditedTransferOrderItemDialog = true
    },
    async getTransferOrder () {
      this.isLoadingTransferOrder = true
      let params = {
        CustomerId: this.filterTransferOrder.CustomerId,
        LicensePlate: this.filterTransferOrder.LicensePlate,
        Number: this.filterTransferOrder.Number,
        Status: this.transferOrderStatus.SalePending
      }
      let response = await HttpTransferOrder.GetTransferOrders(params)

      this.transferOrderList = response && response.status === 200 ? response.data.Data : []
      this.isLoadingTransferOrder = false
    },
    async isShowEditedTransferOrderDialogBtn (item) {
      this.editedTransferOrderIndex = this.transferOrderList.indexOf(item)
      this.editedTransferOrder = JSON.parse(JSON.stringify(item))
      await this.getNotInCustomerRepairItems()
      if (this.notInCustomerTimer) {
        clearInterval(this.notInCustomerTimer)
      }
      this.notInCustomerTimer = setInterval(async () => {
        await this.getNotInCustomerRepairItems()
      }, 30000)
      this.isShowEditedTransferOrderDialog = true
    },
    async getNotInCustomerRepairItems () {
      let response = await HttpCustomerRepair.GetNotInCustomerRepairItems(this.editedTransferOrder)
      this.errorMessage = response && response.status === 200 ? response.data.Data : ''
    },
    async closeEditedTransferOrderDialog () {
      if (this.notInCustomerTimer) {
        clearInterval(this.notInCustomerTimer)
        this.notInCustomerTimer = null
      }
      this.isShowEditedTransferOrderDialog = false
      this.$nextTick(() => {
        this.editedTransferOrderIndex = -1
        this.errorMessage = ''
        this.editedTransferOrder = JSON.parse(JSON.stringify(this.defaultTransferOrder))
      })
      await this.getTransferOrder()
    },
    async setFilterCustomer (val) {
      this.filterTransferOrder.CustomerId = val.Id
      this.filterTransferOrder = JSON.parse(JSON.stringify(this.filterTransferOrder))
    },
    openOriginalQuotation () {
      this.isShowOriginalQuotationDialog = true
      this.originalQuotationItems = this.editedTransferOrder.TransferOrderItems.filter(
        (x) => x.OriginalQuotationItem && x.OriginalQuotationItem.Id
      ).map((x) => x.OriginalQuotationItem)
    },
    async submitToDone () {
      try {
        const response = await HttpTransferOrder.ThrowAndUpdateQuotation(this.editedTransferOrder)
        if (response && response.status === 200) {
          alert(this.$t('common_operation_success'))
          this.closeEditedTransferOrderDialog()
        } else {
          alert(response?.data?.Status?.Message || this.$t('common_operation_failed'))
        }
      } catch (error) {
        console.error('submitToDone error:', error)
        alert(error.response?.data?.Status?.Message || this.$t('common_operation_failed'))
      }
    },
    async returnToStock () {
      try {
        const response = await HttpTransferOrder.ReturnToStock(this.editedTransferOrder.Id)
        if (response && response.status === 200) {
          alert(this.$t('common_operation_success'))
          this.closeEditedTransferOrderDialog()
        } else {
          alert(response?.data?.Status?.Message || this.$t('common_operation_failed'))
        }
      } catch (error) {
        console.error('returnToStock error:', error)
        alert(error.response?.data?.Status?.Message || this.$t('common_operation_failed'))
      }
    },
    async invalidAll () {
      const isValid = await this.$refs.invalidAll.validate()
      if (!isValid) {
        return
      }

      try {
        const response = await HttpTransferOrder.InvalidAndReopenQuotation({
          Number: this.editedTransferOrder.Number,
          InvalidReason: this.invalidReason
        })
        if (response && response.status === 200) {
          alert(this.$t('common_operation_success'))
          await this.closeInvalidAllDialog()
        } else {
          alert(response?.data?.Status?.Message || this.$t('common_operation_failed'))
        }
      } catch (error) {
        console.error('invalidAll error:', error)
        alert(error.response?.data?.Status?.Message || this.$t('common_operation_failed'))
      }
    },
    async closeInvalidAllDialog () {
      this.isShowInvalidAllDialog = false
      this.invalidReason = ''
      await this.searchEditedTransferOrder()
    },
    closeEditedTransferOrderItem () {
      this.isShowEditedTransferOrderItemDialog = false
      this.editedTransferOrderItemIndex = -1
      this.editedTransferOrderItem = JSON.parse(JSON.stringify(this.defaultTransferOrderItem))
    },
    async searchEditedTransferOrder () {
      let response = await HttpTransferOrder.GetTransferOrderByNumber({
        number: this.editedTransferOrder.Number
      })
      if (response && response.status === 200) {
        this.editedTransferOrder = JSON.parse(JSON.stringify(response.data.Data))
      }
    }
  }
}
</script>
